import React, { useContext } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faCog } from '@fortawesome/free-solid-svg-icons'
import NavDropdown from 'react-bootstrap/NavDropdown'
import UserContext from 'context/user-context'
import AppSwitcher from 'layout/app-switcher'
import { hasMultipleApps } from 'layout/app-access'
import DatumLogo from 'assets/DatumInsights/datum-logo.webp'
import ThirdLineLogo from 'assets/MainLogo/Navy/ThirdLine Main Logo Navy.svg'

const DatumNavbar = () => {
  const { logout } = useAuth0()
  const currentUser = useContext(UserContext)

  return (
    <nav
      className="navbar fixed-top datum-navbar flex-md-nowrap p-0 shadow-sm"
      style={{ minHeight: '54px' }}
    >
      <a
        className="navbar-brand d-flex align-items-center"
        href="/datum"
        style={{ minHeight: '54px', width: '200px' }}
      >
        <img
          src={DatumLogo}
          className="ms-3"
          alt="Datum Insights Logo"
          style={{ maxHeight: '35px' }}
        />
        <img
          src={ThirdLineLogo}
          className="ms-3"
          alt="ThirdLine Logo"
          style={{ maxHeight: '22.5px' }}
        />
      </a>
      <div className="container-fluid">
        <h5 className="text-left mt-2 datum-title mb-0">Datum Insights</h5>
        <div className="d-flex ms-auto">
          {hasMultipleApps(currentUser) && <AppSwitcher currentApp="datum" />}
          <ul className="navbar-nav px-2">
            <NavDropdown
              title={
                <span style={{ color: 'var(--datum-navy)' }}>
                  {currentUser.first_name} {currentUser.last_name}
                </span>
              }
              align="end"
            >
              <NavDropdown.Item disabled>
                <small className="text-muted">{currentUser.email}</small>
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/settings">
                <FontAwesomeIcon icon={faCog} className="me-2" />
                Settings
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => logout({ returnTo: window.location.origin })}
              >
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                Sign out
              </NavDropdown.Item>
            </NavDropdown>
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default DatumNavbar
